export default {
      id: "tax-label-usage",
      viewBox: "0 0 91 20",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#tax-label",
      toString: function () {
        return this.url;
      }
    }